import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '../../ui/text/Paragraph';
import { Button } from '../button/Button';
import { Image } from '../image/Image';
import { Heading } from '../text/Heading';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledArticleCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1em;
  background-color: ${({ theme }) => theme.colors.burgundy_card};
  z-index: 50;

  h2 {
    text-align: center;
  }

  h3 {
    text-align: center;
  }

  .description {
    padding: 1em 1em;
    width: 100%;
    max-width: 450px;
    margin: 2em auto 1em auto;
  }

  .card-image-overlay {
    height: 50%;
    max-height: 100px;
  }

  @media all and (min-width: 600px) {
    position: relative;
    padding: 2em;

    .description {
      padding: 0 1em;
    }
    h3 {
      margin: 0 auto;
      margin-bottom: 20px;
    }
  }
`;
const ArticleWrapper = styled.div`
  img {
    object-fit: cover;
  }
`;

const ButtonGridColumn = styled.div`
  display: block;
  align-self: center;
  padding-top: 10px;
`;

const ButtonGrid = styled.div`
  display: grid;
  width: 100%;
  justify-content: center;
  grid-template-columns: repeat(2, max-content);
  grid-column-gap: 10px;

  @media all and (max-width: 330px) {
    grid-template-columns: max-content;
    grid-row-gap: 10px;
  }
`;

interface IArticleCard {
  title?: string;
  image?: string;
  imageOverlay?: string;
  description?: string;
  link?: string;
  buttonLabel?: string;
}

export const ArticleCard: React.FC<IArticleCard> = React.memo(
  ({ title, image, imageOverlay, description, link, buttonLabel }) => {
    return (
      <StyledArticleCard>
        <Wrapper>
          <h3 dangerouslySetInnerHTML={{ __html: title as string }} />
          <ArticleWrapper>
            <Image url={image || ''} height="300px" alt="artikke-bilde">
              {imageOverlay ? (
                <img src={imageOverlay} className="card-image-overlay" />
              ) : null}
            </Image>
          </ArticleWrapper>
        </Wrapper>
        <Paragraph className="description" center={true}>
          {description}
        </Paragraph>
        <ButtonGrid>
          <ButtonGridColumn>
            <Button
              type="primary"
              colorTheme="gold"
              as="link"
              className="cardbutton"
              to={link}
            >
              {buttonLabel ? buttonLabel : 'Til episode'}
            </Button>
          </ButtonGridColumn>
        </ButtonGrid>
      </StyledArticleCard>
    );
  }
);
